import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import * as PIXI from "pixi.js";
import { ControlPanelLandscapeProperties, OptionsLandscapeProperties, StakeSelectorLandscapeProperties } from "../landscape/ControlPanelLandscapeProperties";
import { Point } from "pixi.js";
/**
 * ControlPanelPortraitProperties.ts
 */
export class ControlPanelPortraitProperties extends ControlPanelLandscapeProperties {
    constructor() {
        super();
        this.spinButtonPosition = new PIXI.Point(347.5, 1558);
        this.spinButtonProperties.scale.set(1.28);
        this.startGameButtonProperties.scale.set(1.28);
        this.freeSpinButtonProperties.scale.set(1.28);
        this.purchaseSpinButtonProperties.scale.set(1.28);
        this.logoProperties.position.set(195, 35);
        this.logoProperties.scale.set(1);
        this.playFeatureButtonProperties.position.set(58, 1321);
        this.endGameButtonProperties.position.set(58, 1321);
        this.collectButtonProperties.position.set(58, 1321);
        this.collectButtonProperties.scale.set(1);
        this.collectButtonProperties.movieClipProperties.scale.set(1);
        this.collectButtonProperties.disableAlign = true;
        this.collectButtonProperties.textFieldProperties.position.set(300, 20);
        this.collectButtonProperties.textFieldProperties.fontProperties.trim = true;
        this.collectButtonProperties.textFieldProperties.size = new PIXI.Point(400, 120);
        this.collectButtonProperties.disableTextAlpha = 1;
        this.collectButtonValueTextFieldProperties.position = new PIXI.Point(300, 100);
        this.collectButtonValueTextFieldProperties.fontProperties.trim = true;
        this.collectButtonValueTextFieldProperties.size = new PIXI.Point(400, 80);
        this.endGameButtonProperties.disableAlign = true;
        this.endGameButtonProperties.textFieldProperties.position.set(452, 25);
        this.endGameButtonProperties.movieClipProperties.scale.set(1);
        this.endGameButtonProperties.textFieldProperties.fontProperties.trim = true;
        this.endGameButtonProperties.textFieldProperties.size = new PIXI.Point(800, 160);
        this.payTableButtonProperties.position.set(45, 1594);
        this.payTableButtonProperties.scale.set(0.88);
        this.payTableButtonProperties.textFieldOffset.set(0, -6);
        this.payTableButtonProperties.textFieldProperties.size = new PIXI.Point(175, 80);
        Object.values(this.collectIcons).forEach(icon => {
            icon.position = new Point(770, 1550);
            icon.anchor = new Point(0.5, 1);
            icon.scale = new Point(0.34, 0.34);
        });
    }
}
/**
 * StakeSelectorPortraitProperties.ts
 */
export class StakeSelectorPortraitProperties extends StakeSelectorLandscapeProperties {
    constructor() {
        super();
        this.position.set(0, 0);
        this.scale.set(1);
        this.panelProperties.position.set(155, 330);
        this.panelProperties.scale.set(1);
        this.toggleButtonProperties.scale.set(0.88);
        this.toggleButtonProperties.position.set(806, 1757);
    }
}
/**
 * OptionsPortraitProperties.ts
 */
export class OptionsPortraitProperties extends OptionsLandscapeProperties {
    constructor() {
        super();
        this.panelProperties.scale.set(1);
        this.backgroundAlpha = 0.72;
        this.optionsButtonProperties.position.set(45, 1757);
        this.optionsButtonProperties.scale.set(0.88);
        this.optionsMenuProperties.position.set(163, 640);
        this.optionsMenuProperties.spriteSheet = undefined;
        this.panelProperties.position.set(-30, -180);
        this.payTableButtonProperties.position.set(45, 1593);
        this.payTableButtonProperties.scale.set(0.88);
        let size = new PIXI.Point(500, 100);
        let textFieldOffset = new PIXI.Point(-235, 0);
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.payTableButtonProperties.textFieldProperties.size = size;
        this.payTableButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.payTableButtonProperties.textFieldOffset = textFieldOffset;
        this.SFXButtonProperties.textFieldProperties.size = size;
        this.SFXButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.SFXButtonProperties.textFieldOffset = textFieldOffset;
        this.backgroundSoundButtonProperties.textFieldProperties.size = size;
        this.backgroundSoundButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.backgroundSoundButtonProperties.textFieldOffset = textFieldOffset;
        this.helpButtonProperties.textFieldProperties.size = size;
        this.helpButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.helpButtonProperties.textFieldOffset = textFieldOffset;
        this.homeButtonProperties.textFieldProperties.size = size;
        this.homeButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.homeButtonProperties.textFieldOffset = textFieldOffset;
        this.depositButtonProperties.textFieldProperties.size = size;
        this.depositButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.depositButtonProperties.textFieldOffset = textFieldOffset;
        this.dghButtonProperties.textFieldProperties.size = size;
        this.dghButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.dghButtonProperties.textFieldOffset = textFieldOffset;
        this.responsibleGamingButtonProperties.textFieldProperties.size = size;
        this.responsibleGamingButtonProperties.textFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.responsibleGamingButtonProperties.textFieldOffset = textFieldOffset;
        this.hasPayTable = false;
    }
}
